import { initNavigationData } from '@/utils/store/history/historyNavigation';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { HistoryState } from './types/index';

export { namespace } from './types/index';

export const state: HistoryState = {
  historyState: {
    loading: {
      history: false,
      filters: false
    },
    error: {
      history: false,
      filters: false
    },
    fetched: {
      history: false,
      filters: false
    }
  },
  history: {
    totalSize: 0,
    history: []
  },
  filters: [],
  selectedFilters: {
    start: 0,
    size: initNavigationData.size,
    deviceId: undefined,
    historyType: undefined,
    plateNumber: undefined,
    from: undefined,
    to: undefined
  },
  selectedFilterCategories: [],
  navigation: initNavigationData,
  errorMessage: ''
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
